module.exports = __webpack_public_path__ + "files/0af57ce839d17517fd1942f6c7ec00a5.png";